import IBullData from "../models/IBullData";
import { Action, ActionType } from "../actions/BullCodeActions";

// Define the state interface for the current reducer
export interface IState {
  bullOptions: IBullData[];
  selectedBulls: IBullData[];
}

// Define the initial state
export const initialState: IState = {
  bullOptions: [],
  selectedBulls: [],
};

export function reducer(state: IState = initialState, action: Action) {
  switch (action.type) {
    case ActionType.ReceiveBullOptions: {
      return {
        ...state,
        bullOptions: action.payload,
      };
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/scripts/reducers/BullCodeReducer.ts